import ModuleEmptyState from './ModuleEmptyState';

export default ModuleEmptyState;
